// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-module--container--3Dvn1","copyright":"Footer-module--copyright--2uglW"};